export const TOO_MANY_PRODUCTS_MESSAGE = `We're sorry, you've exceeded the maximum number of items (89) 
allowed in a quote. Select fewer items and try again.`;
export const QUANTITY_LIMIT = 9999;
export const NO_ITEMS_SELECTED_ATC_MESSAGE = 'Select an item to Add to Cart';

// Progress Bar Drawer Constants
export const PRODUCTS_LOADING_MESSAGE = `We are fetching important information for the items you have 
selected. You will be redirected momentarily...`;